import { createServerFn } from "@tanstack/react-start";
import { Result } from "better-result";
import { authMiddleware } from "#/modules/util.auth/middleware.auth";
import { getBeweegThemaMapping } from "./api.master-data.server";

/**
 * Global (not school-scoped) master-data for the authenticated layout loader.
 *
 * Loaded at the `_authenticated` layout (portal parity: RR7 loads it in `_protected`) — the common
 * ancestor of BOTH the `$school` tree and the school-less `admin` tree — so `useMasterData()` can
 * resolve it in either tree. Previously it lived in the `$school` layout loader, which made the
 * admin add/edit master-data forms crash (no `$school` match to read from).
 */
export const getMasterData = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async () => {
    const result = await getBeweegThemaMapping();
    if (Result.isError(result)) {
      throw result.error;
    }
    return {
      beweegThemaMapping: result.value,
    };
  });
